import { Component, OnInit } from '@angular/core';
import { FormBuilder, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { UtilityService } from 'src/app/services/utility.service';
import { ThemeService } from 'src/app/services/theme.service';
import { FeatureFlagService } from 'src/app/services/feature-flag.service';
import { environment } from 'src/environments/environment';
import { messages } from '../../../../../common/messages'
import { regex ,EmailNoWhitespaceValidator} from '../../../../../common/regex';
import icVisibility from '@iconify/icons-ic/twotone-visibility';
import icVisibilityOff from '@iconify/icons-ic/twotone-visibility-off';

@Component({
    selector: 'app-admin-sign-in',
    templateUrl: './admin-sign-in.component.html',
    styleUrls: ['./admin-sign-in.component.scss'],
    standalone: false
})
export class AdminSignInComponent implements OnInit {

  assets=environment.assets;
  public form: any;
  message: any
  emailRegex = regex.pattern.EMAIL
  passwordRegex = regex.pattern.PASSWORD
  hide = true;
  hide1 = true;
  hide2 = true;
  icVisibility = icVisibility;
  icVisibilityOff = icVisibilityOff;
  logoPath: string = '';
  isSpecialtyIntakeEnabled: boolean = false;

  constructor(
    public router: Router,
    private fb: FormBuilder,
    private api: ApiService,
    private utility: UtilityService,
    public themeService: ThemeService,
    private featureFlagService: FeatureFlagService
    ) { }

  ngOnInit(): void {
    this.message = messages
    this.isSpecialtyIntakeEnabled = this.featureFlagService.isSpecialtyIntakeEnabled();
    this.logoPath = this.themeService.getLogoPath();
    this.setupSigninForm();
  }

  setupSigninForm() {
    this.form = this.fb.group({
      email: [null,
        Validators.compose([
          Validators.required,
          EmailNoWhitespaceValidator])],

      password: [null,
        Validators.compose([
          Validators.required,
          Validators.pattern(this.passwordRegex)])]
    });
  }
  signIn(userData: any) {
    this.utility.setSpinner(true)
    userData['userType'] = 'admin'

    this.api.apiRequest("post", "user/signin", userData)
      .subscribe(result => {
        this.utility.setSpinner(false)

        if (result.status == "success") {
          this.utility.openSnackBar("Signin successful.", "Ok" )
          let userData = result.data;

          if (userData.userType == 'admin') {
            // When specialty intake is enabled, redirect admin to appointments instead of dashboard
            const redirectPath = this.isSpecialtyIntakeEnabled
              ? 'admin/manage-appointments/list'
              : 'admin/dashboard';
            this.router.navigate([redirectPath]);

          }
          // // Store the values in local storage
          localStorage.setItem("endUserEmail", userData.email)
          localStorage.setItem("endUserId", userData._id)
          localStorage.setItem("endUserType", userData.userType)
          localStorage.setItem("endUserFullName", userData.firstName + ' ' + userData.lastName)
          localStorage.setItem("endUserFirstName", userData.firstName)
          localStorage.setItem("endUserLastName", userData.lastName)
          localStorage.setItem("accessToken", userData.accessToken)
          localStorage.setItem("contactNumber", userData.contactNumber)


        } else {

          if (result.data.invalidEmail) {
            this.form.controls['email'].setErrors({ 'invalidEmail': true })
          } else if (result.data.invalidPassword) {

            this.form.controls['password'].setValue('');
            this.form.controls['password'].markAsUntouched();
            this.form.controls['password'].setErrors({ 'invalidPassword': true });
          } else if (result.data.accountNotVerified) {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'accountNotVerified': true })
          }
          else if (result.data.otherAccount) {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'invalidLoginType': true })
          }
          else {
            this.form.controls['email'].markAsUntouched();
            this.form.controls['email'].setErrors({ 'differentAccount': false })
          }
        }

      }, (err) => {
        this.utility.setSpinner(false)
        // this.router.navigate(["/error/404"])
      })
  }

  /**
   * Initiate SAML SSO login
   * Only available when SPECIALTY_INTAKE_ENABLED feature flag is true
   */
  loginWithEntra(): void {
    if (!this.isSpecialtyIntakeEnabled) {
      return;
    }

    // SAML SP-initiated: direct browser redirect to backend login endpoint
    const serverUrl = this.api.serverUrl;
    window.location.href = `${serverUrl}/api/auth/saml/login`;
  }
}
